import React from 'react';
import { Card, Placeholder } from 'react-bootstrap';

/**
 * Placeholder rows shaped like the list they stand in for, so the page does
 * not jump when the data arrives. Never renders nothing.
 */
function LoadingState({ rows = 3, label = 'Loading' }) {
    const count = Math.max(1, rows);
    return (
        <div role="status" aria-busy="true" aria-live="polite">
            <span className="visually-hidden">{label}</span>
            {Array.from({ length: count }, (_, i) => (
                <Card key={i} className="mb-3 border-0 shadow-sm" aria-hidden>
                    <Card.Body>
                        <Placeholder as="p" animation="glow" className="mb-2">
                            <Placeholder xs={4} />
                        </Placeholder>
                        <Placeholder as="p" animation="glow" className="mb-0">
                            <Placeholder xs={9} />
                        </Placeholder>
                    </Card.Body>
                </Card>
            ))}
        </div>
    );
}

export default LoadingState;
